import React, { useState, useEffect } from "react";
import { fetchOrderIds } from "../../../api/request";
import { Order } from "../../../types/requestModel";
import style from "./Account.module.scss";

declare global {
  interface Window {
    customerId: number;
  }
}

export const Account: React.FC = () => {
  const [customerId, setCustomerId] = useState(Number);
  const [isLoading, setIsLoading] = useState(false);
  let [data, setData] = useState<Order[] | null>(null);

  useEffect(() => {
    setCustomerId(window.customerId);
  }, []);

  useEffect(() => {
    if (customerId !== null && customerId !== 0) {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          const orderIds = await fetchOrderIds(customerId);
          setData(orderIds);
        } catch (error) {
          console.error("Error fetching order IDs:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [customerId]);

  return (
    <>
      {isLoading ? (
        <div className={style.loading}>
          <p>注文を読み込み中...</p>
        </div>
      ) : (
        data &&
        data.length > 0 && (
          <table className="p-tam-ordered__table">
            <tbody role="rowgroup">
              {data.map((order) => (
                <tr role="row" key={order.orderId}>
                  <td>{order.orderDate}</td>
                  <td>{order.orderItem}</td>
                  <td>{order.orderMenu}</td>
                  <td>
                    ID:
                    <span>{order.orderId}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}
      {!isLoading && data && data.length === 0 && <p>注文はまだありません。</p>}
    </>
  );
};
